import { render, staticRenderFns } from "./otherForm.vue?vue&type=template&id=6462e2e8&scoped=true&"
import script from "./otherForm.vue?vue&type=script&lang=js&"
export * from "./otherForm.vue?vue&type=script&lang=js&"
import style0 from "./otherForm.vue?vue&type=style&index=0&id=6462e2e8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6462e2e8",
  null
  
)

export default component.exports